const catalogCache = new Map();

export const REFLEX_VISUAL_ASSETS = {
  background: '/mini-tasks/reflex/assets/v2/garden-background-v2.png',
  burrow: '/mini-tasks/reflex/assets/v2/burrow-v2.png',
  burrowFront: '/mini-tasks/reflex/assets/v2/burrow-front-v2.png',
  panda: '/mini-tasks/reflex/assets/v2/panda-target-v2.png',
  sleepy: '/mini-tasks/reflex/assets/v2/sleepy-distractor-v2.png',
};

export function manifestPathForVersion(version) {
  return `/mini-tasks/reflex/manifest.v${Number(version)}.json`;
}

export async function loadReflexCatalog(version) {
  const catalogVersion = Number(version);
  if (!catalogCache.has(catalogVersion)) {
    catalogCache.set(
      catalogVersion,
      fetch(manifestPathForVersion(catalogVersion), { cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error('Refleks karakterleri yüklenemedi.');
          return response.json();
        })
        .then((manifest) => {
          if (
            Number(manifest.version) !== catalogVersion
            || !manifest.targets?.length
            || !manifest.distractors?.length
          ) {
            throw new Error('Refleks karakter kataloğu geçerli değil.');
          }
          return manifest;
        }).catch((error) => {
          catalogCache.delete(catalogVersion);
          throw error;
        }),
    );
  }
  return catalogCache.get(catalogVersion);
}

export function clearReflexCatalogCache() {
  catalogCache.clear();
}
